module.exports = __webpack_public_path__ + "static/speed-2@2x-681ab7c012c3bef13552ff931a26fe31.png";